import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEAeronauticalCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Aeronautical Engineering",
    shortName: "B.E. Aeronautical",
    duration: "4 years",
    description: "Engineering program focused on design, development, and manufacturing of aircraft and aerospace systems",
    overview: "Bachelor of Engineering in Aeronautical Engineering (B.E. Aeronautical) is a 4-year undergraduate program that deals with the design, construction, and maintenance of aircraft and spacecraft. This course covers aerodynamics, propulsion systems, avionics, materials science, and flight mechanics, preparing students for careers in the aerospace and aviation industries.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Strong mathematical and analytical skills"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Workshop Technology",
          "Computer Programming"
        ]
      },
      {
        year: 2,
        subjects: [
          "Strength of Materials",
          "Thermodynamics",
          "Fluid Mechanics",
          "Materials Science",
          "Engineering Mechanics",
          "Manufacturing Processes"
        ]
      },
      {
        year: 3,
        subjects: [
          "Aerodynamics",
          "Aircraft Structures",
          "Propulsion Systems",
          "Flight Mechanics",
          "Avionics",
          "Control Systems"
        ]
      },
      {
        year: 4,
        subjects: [
          "Aircraft Design",
          "Space Technology",
          "Composite Materials",
          "Computational Fluid Dynamics",
          "Project Work",
          "Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Aeronautical Engineer",
        "Aircraft Design Engineer",
        "Flight Test Engineer",
        "Maintenance Engineer",
        "Research Scientist",
        "Quality Assurance Engineer",
        "Project Manager",
        "Technical Consultant"
      ],
      industries: [
        "Aircraft Manufacturing",
        "Airlines and Aviation",
        "Defense Organizations",
        "Space Research (ISRO)",
        "Aircraft Maintenance",
        "Consulting Firms",
        "Research Institutions",
        "Government Aviation Departments"
      ],
      averageSalary: "₹5-10 LPA (Fresher), ₹15-35 LPA (Experienced)",
      topRecruiters: [
        "ISRO, HAL, DRDO",
        "Air India, IndiGo",
        "Boeing, Airbus",
        "Rolls Royce, GE Aviation",
        "Tata Advanced Systems",
        "L&T Defence"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and IIITs)",
      "JEE Advanced (for IITs)",
      "State-level entrance exams",
      "Management quota admissions"
    ],

    topColleges: [
      {
        name: "Indian Institute of Technology Madras",
        location: "Chennai",
        fees: "₹8,00,000 (4 years)",
        ranking: "NIRF Ranking: 1"
      },
      {
        name: "Indian Institute of Technology Bombay",
        location: "Mumbai",
        fees: "₹8,00,000 (4 years)",
        ranking: "NIRF Ranking: 3"
      },
      {
        name: "Madras Institute of Technology",
        location: "Chennai",
        fees: "₹2,50,000 (4 years)",
        ranking: "Anna University Constituent"
      },
      {
        name: "Hindustan Institute of Technology",
        location: "Chennai",
        fees: "₹12,00,000 (4 years)",
        ranking: "NAAC A Grade"
      },
      {
        name: "Vel Tech Rangarajan Dr. Sagunthala R&D Institute",
        location: "Chennai",
        fees: "₹3,60,000 per year",
        ranking: "NAAC A Grade"
      }
    ],

    skills: [
      "Aircraft Design",
      "Aerodynamics Analysis",
      "CAD Software (CATIA, SolidWorks)",
      "Flight Testing",
      "Materials Engineering",
      "Project Management",
      "Technical Documentation",
      "Problem Solving",
      "Systems Thinking",
      "Safety Analysis"
    ],

    futureScope: "Excellent growth potential with expanding aviation industry, space exploration missions, drone technology, and defense modernization programs in India and globally.",

    faqs: [
      {
        question: "Is Aeronautical Engineering only about building planes?",
        answer: "No, it covers aircraft design, maintenance, testing, space technology, drones, missiles, and various aerospace applications beyond just commercial aircraft."
      },
      {
        question: "Are there opportunities in ISRO?",
        answer: "Yes, ISRO regularly recruits aeronautical engineers for satellite and rocket development, space missions, and research projects."
      },
      {
        question: "Can I work in airlines?",
        answer: "Yes, airlines hire aeronautical engineers for aircraft maintenance, flight operations, technical support, and safety management roles."
      },
      {
        question: "What about opportunities abroad?",
        answer: "Excellent international opportunities with companies like Boeing, Airbus, NASA, SpaceX, and aviation companies worldwide."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEAeronauticalCoursePage;
